/* Zam Zam Signature theme. No dependencies. Most behavior is event-delegated so it keeps working after content is swapped in. */
(() => {
  'use strict';

  const T = window.theme || { strings: {}, routes: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(key, fallback) { try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage may be blocked */ } }
  };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '${{amount}}';
    const group = (value, sep, dec) => {
      const [i, d] = value.split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (d ? dec + d : '');
    };
    const c = Number(cents) || 0;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return group((c / 100).toFixed(0), ',', '.');
        case 'amount_with_comma_separator': return group((c / 100).toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group((c / 100).toFixed(0), '.', ',');
        default: return group((c / 100).toFixed(2), ',', '.');
      }
    });
  };

  let toastTimer;
  const toast = (msg) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  };

  /* Dialogs */
  const openDialog = (d) => { if (d && !d.open) d.showModal(); };
  const closeDialog = (d) => { if (d && d.open) d.close(); };

  document.addEventListener('click', (e) => {
    const t = e.target;
    const opener = t.closest('[data-dialog-open]');
    if (opener) { e.preventDefault(); openDialog(document.getElementById(opener.dataset.dialogOpen)); return; }
    const closer = t.closest('[data-dialog-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (t.tagName === 'DIALOG') { // click on the backdrop
      const r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(t);
    }
  });

  /* Copy coupon, activate coupon, share */
  const copyText = async (text) => {
    try { await navigator.clipboard.writeText(text); return true; }
    catch {
      const a = document.createElement('textarea');
      a.value = text; document.body.append(a); a.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch { /* unsupported */ }
      a.remove();
      return ok;
    }
  };

  document.addEventListener('click', async (e) => {
    const copy = e.target.closest('[data-copy]');
    if (copy) { e.preventDefault(); if (await copyText(copy.dataset.copy)) toast(T.strings.copied); return; }

    const act = e.target.closest('[data-activate-coupon]');
    if (act) {
      e.preventDefault();
      const code = act.dataset.activateCoupon;
      try {
        await fetch(`${T.routes.root.replace(/\/$/, '')}/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });
        await copyText(code);
        const label = $('[data-coupon-label]', act);
        if (label) label.textContent = `${code} ✓`;
        toast(`${code} ✓`);
        refreshCart();
      } catch { toast(T.strings.error); }
      return;
    }

    const share = e.target.closest('[data-share]');
    if (share) {
      const data = { title: share.dataset.title, url: share.dataset.url };
      if (navigator.share) { navigator.share(data).catch(() => {}); }
      else if (await copyText(data.url)) toast(T.strings.copied);
      return;
    }

    const top = e.target.closest('[data-back-to-top]');
    if (top) window.scrollTo({ top: 0 });
  });

  /* Cart */
  const CART_SECTIONS = () => {
    const ids = ['cart-drawer'];
    const page = $('[data-cart-section]');
    if (page) ids.push(page.dataset.cartSection);
    return ids;
  };

  const applyCartSections = (sections) => {
    if (!sections) return;
    const docHtml = sections['cart-drawer'];
    if (docHtml) {
      const fresh = $('#CartDrawerInner', parse(docHtml));
      const current = $('#CartDrawerInner');
      if (fresh && current) {
        const openIdx = $$('details', current).map((d) => d.open);
        current.replaceWith(fresh);
        $$('details', fresh).forEach((d, i) => { if (openIdx[i]) d.open = true; });
        const count = fresh.dataset.itemCount;
        $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === '0'; });
      }
    }
    const page = $('[data-cart-section]');
    if (page && sections[page.dataset.cartSection]) {
      const fresh = $('#CartPageInner', parse(sections[page.dataset.cartSection]));
      const current = $('#CartPageInner');
      if (fresh && current) current.replaceWith(fresh);
    }
  };

  const refreshCart = async () => {
    const ids = CART_SECTIONS().join(',');
    const res = await fetch(`${T.routes.root}?sections=${ids}`, { credentials: 'same-origin' });
    if (res.ok) applyCartSections(await res.json());
  };

  const showAdded = () => {
    if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
    closeDialog($('#QuickView'));
    openDialog($('#CartDrawer'));
  };

  const addToCart = async (body) => {
    const res = await fetch(`${T.routes.cartAdd}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: CART_SECTIONS(), sections_url: window.location.pathname })
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || T.strings.error);
    applyCartSections(json.sections);
    return json;
  };

  const cartPost = async (route, body) => {
    const panel = $('#CartDrawerInner');
    if (panel) panel.classList.add('is-updating');
    try {
      const res = await fetch(`${route}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: CART_SECTIONS(), sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok || json.status) { toast(json.description || json.message || T.strings.error); await refreshCart(); return; }
      applyCartSections(json.sections);
    } catch { toast(T.strings.error); }
    finally { const p = $('#CartDrawerInner'); if (p) p.classList.remove('is-updating'); }
  };

  document.addEventListener('click', async (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && T.cartType !== 'page' && !$('[data-cart-section]')) { e.preventDefault(); openDialog($('#CartDrawer')); return; }

    const line = e.target.closest('[data-line-change]');
    if (line) { cartPost(T.routes.cartChange, { line: Number(line.dataset.lineChange), quantity: Number(line.dataset.qty) }); return; }

    const removeCode = e.target.closest('[data-discount-remove]');
    if (removeCode) {
      const remaining = $$('[data-discount-remove]', removeCode.closest('.cart-extra'))
        .map((b) => b.dataset.discountRemove).filter((c) => c !== removeCode.dataset.discountRemove);
      cartPost(T.routes.cartUpdate, { discount: remaining.join(',') });
      return;
    }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      try { await addToCart({ items: [{ id: Number(quick.dataset.quickAdd), quantity: 1 }] }); showAdded(); }
      catch (err) { toast(err.message); }
      finally { quick.classList.remove('is-loading'); }
      return;
    }

    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('input', step.parentElement);
      const next = Math.max(Number(input.min) || 0, (Number(input.value) || 0) + Number(step.dataset.qtyStep));
      input.value = next;
    }
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-line-input]')) cartPost(T.routes.cartChange, { line: Number(t.dataset.lineInput), quantity: Math.max(0, Number(t.value) || 0) });
    if (t.matches('[data-cart-note]')) cartPost(T.routes.cartUpdate, { note: t.value });
    if (t.matches('[data-cart-attribute]')) cartPost(T.routes.cartUpdate, { attributes: { [t.dataset.cartAttribute]: t.value } });
    if (t.matches('[data-auto-submit]')) t.form.submit();
    if (t.matches('[data-option-index]')) onVariantChange(t);
    if (t.matches('[data-facets-input]') && !t.matches('[data-debounce]')) applyFacets();
    if (t.matches('[data-country-select]')) syncProvinces(t);
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;

    if (form.matches('[data-discount-form]')) {
      e.preventDefault();
      const code = form.elements.discount.value.trim();
      if (!code) return;
      const existing = $$('[data-discount-remove]', form.closest('.cart-extra')).map((b) => b.dataset.discountRemove);
      cartPost(T.routes.cartUpdate, { discount: [...existing, code].join(',') });
      return;
    }

    if (form.dataset.confirm && !window.confirm(form.dataset.confirm)) { e.preventDefault(); return; }

    if ((form.getAttribute('action') || '').includes('/cart/add')) {
      e.preventDefault();
      const buttons = [...$$('[data-add-button]', form), ...$$(`[form="${form.id}"][data-add-button]`)];
      const error = $('[data-form-error]', form);
      if (error) error.hidden = true;
      buttons.forEach((b) => b.classList.add('is-loading'));
      const data = new FormData(form);
      const item = { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 };
      if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
      const properties = {};
      for (const [k, v] of data.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) properties[m[1]] = v; }
      if (Object.keys(properties).length) item.properties = properties;
      try { await addToCart({ items: [item] }); showAdded(); }
      catch (err) { if (error) { error.textContent = err.message; error.hidden = false; } else toast(err.message); }
      finally { buttons.forEach((b) => b.classList.remove('is-loading')); }
    }
  });

  /* Variant picker */
  function onVariantChange(input) {
    const root = input.closest('[data-product-root]');
    if (!root) return;
    const json = $('[data-variants-json]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const selected = [];
    $$('[data-option-index]:checked', root).forEach((r) => { selected[Number(r.dataset.optionIndex)] = r.value; });
    const index = input.dataset.optionIndex;
    const label = $(`[data-option-value="${index}"]`, root);
    if (label) label.textContent = input.value;
    const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
    updateVariant(root, variant);
  }

  function updateVariant(root, v) {
    $$('[data-variant-id]', root).forEach((el) => { if (v) el.value = v.id; });
    $$('[data-add-button]', root).forEach((btn) => {
      btn.disabled = !v || !v.available;
      const label = $('[data-add-label]', btn);
      if (label) label.textContent = !v ? T.strings.unavailable : v.available ? T.strings.addToBag : T.strings.soldOut;
    });
    if (!v) return;

    const onSale = v.compare > v.price;
    const price = $('[data-price]', root);
    if (price) {
      price.classList.toggle('price--sale', onSale);
      const now = $('[data-price-now]', price);
      if (now) now.textContent = formatMoney(v.price);
      const retailWrap = $('[data-price-retail-wrap]', price);
      if (retailWrap) { retailWrap.hidden = !onSale; $('[data-price-retail]', retailWrap).textContent = onSale ? formatMoney(v.compare) : ''; }
      const save = $('[data-price-save]', price);
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          save.textContent = save.dataset.format === 'amount'
            ? `${T.strings.saveLabel} ${formatMoney(v.compare - v.price)}`
            : `${Math.floor(((v.compare - v.price) * 100) / v.compare)}% off ${save.dataset.label}`;
        }
      }
      const coupon = $('[data-price-coupon-value]', price);
      if (coupon && T.couponPercent) coupon.textContent = formatMoney(Math.floor((v.price * (100 - T.couponPercent)) / 100));
    }
    const sticky = $('[data-sticky-price]', root);
    if (sticky) sticky.textContent = formatMoney(v.price);
    const sku = $('[data-sku]', root);
    if (sku) { sku.hidden = !v.sku; $('[data-sku-value]', sku).textContent = v.sku || ''; }

    const stock = $('[data-stock]', root);
    if (stock) {
      const low = Number(stock.dataset.low) || 0;
      if (!v.available) stock.innerHTML = `<span class="stock__dot stock__dot--out"></span> ${stock.dataset.out}`;
      else if (v.tracked && v.qty > 0 && v.qty <= low) stock.innerHTML = `<span class="stock__dot stock__dot--low"></span> ${stock.dataset.lowText.replace('__N__', v.qty)}`;
      else stock.innerHTML = `<span class="stock__dot"></span> ${stock.dataset.in}`;
    }

    if (v.media) {
      const slide = $(`[data-media-id="${v.media}"]`, root);
      const track = $('[data-gallery-track]', root);
      if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    if (!root.hasAttribute('data-quick')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
  }

  /* Gallery */
  const initGallery = (scope = document) => {
    $$('[data-gallery]', scope).forEach((g) => {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      const track = $('[data-gallery-track]', g);
      const thumbs = $$('[data-gallery-thumb]', g);
      const dots = $$('[data-gallery-dot]', g);
      const setActive = (i) => {
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      }));
      track.addEventListener('scroll', debounce(() => setActive(Math.round(track.scrollLeft / track.clientWidth)), 60), { passive: true });
    });
  };

  document.addEventListener('click', (e) => {
    const zoom = e.target.closest('[data-zoom]');
    if (!zoom) return;
    const box = $('[data-lightbox]');
    if (!box) return;
    const img = $('[data-lightbox-img]', box);
    img.src = zoom.dataset.zoom;
    img.alt = zoom.getAttribute('aria-label') || '';
    openDialog(box);
  });

  /* Quick view */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    const box = $('#QuickView');
    const content = $('#QuickViewContent');
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${btn.dataset.quickView}${btn.dataset.quickView.includes('?') ? '&' : '?'}section_id=quick-view`);
      if (!res.ok) throw new Error();
      const doc = parse(await res.text());
      content.innerHTML = '';
      const view = $('.quick-view', doc);
      content.append(view);
      initGallery(content);
      syncWishlist(content);
      openDialog(box);
    } catch { window.location.href = btn.dataset.quickView; }
    finally { btn.classList.remove('is-loading'); }
  });

  /* Carousels and sliders */
  const updateArrows = (c) => {
    const track = $('.carousel__track', c);
    if (!track) return;
    const prev = $('[data-carousel-prev]', c);
    const next = $('[data-carousel-next]', c);
    if (!prev || !next) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  };

  const initCarousels = (scope = document) => {
    $$('[data-carousel]', scope).forEach((c) => {
      if (c.dataset.ready) { updateArrows(c); return; }
      c.dataset.ready = '1';
      const track = $('.carousel__track', c);
      if (!track) return;
      track.addEventListener('scroll', debounce(() => updateArrows(c), 60), { passive: true });
      updateArrows(c);
    });
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev],[data-carousel-next]');
    if (!btn) return;
    const c = btn.closest('[data-carousel]');
    const track = $('.carousel__track', c);
    const dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });
  window.addEventListener('resize', debounce(() => initCarousels(), 150));

  const initSliders = (scope = document) => {
    $$('[data-slider]', scope).forEach((s) => {
      if (s.dataset.ready) return;
      s.dataset.ready = '1';
      const track = $('[data-slider-track]', s);
      const slides = $$('[data-slide]', s);
      if (slides.length < 2) return;
      const dots = $$('[data-slider-dot]', s);
      let index = 0;
      let timer;
      const go = (i) => { index = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' }); };
      const stop = () => clearInterval(timer);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const start = () => {
        stop();
        if (s.dataset.autoplay === 'true' && !reduced) timer = setInterval(() => go(index + 1), Number(s.dataset.speed || 5) * 1000);
      };
      $('[data-slider-prev]', s)?.addEventListener('click', () => { go(index - 1); stop(); });
      $('[data-slider-next]', s)?.addEventListener('click', () => { go(index + 1); stop(); });
      dots.forEach((d, i) => d.addEventListener('click', () => { go(i); stop(); }));
      track.addEventListener('scroll', debounce(() => {
        index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      }, 60), { passive: true });
      s.addEventListener('pointerenter', stop);
      s.addEventListener('focusin', stop);
      s.addEventListener('pointerleave', start);
      start();
    });
    $$('[data-rotator]', scope).forEach((r) => {
      if (r.dataset.ready) return;
      r.dataset.ready = '1';
      const items = $$('[data-rotator-item]', r);
      if (items.length < 2) return;
      let i = 0;
      const show = (n) => { i = (n + items.length) % items.length; items.forEach((el, k) => el.classList.toggle('is-active', k === i)); };
      let timer = setInterval(() => show(i + 1), Number(r.dataset.speed || 5) * 1000);
      $('[data-rotator-prev]', r)?.addEventListener('click', () => { clearInterval(timer); show(i - 1); });
      $('[data-rotator-next]', r)?.addEventListener('click', () => { clearInterval(timer); show(i + 1); });
      r.addEventListener('focusin', () => clearInterval(timer));
      timer = timer || null;
    });
  };

  /* Tabs, including sorted lists loaded on demand */
  const loadSorted = async (panel) => {
    if (!panel.dataset.sortUrl || panel.dataset.loaded) return;
    panel.dataset.loaded = '1';
    try {
      const res = await fetch(panel.dataset.sortUrl);
      if (!res.ok) return;
      const list = $('[data-cards]', parse(await res.text()));
      const track = $('[data-track]', panel);
      if (!list || !track) return;
      const limit = Number(panel.dataset.limit) || 12;
      const items = $$('.carousel__slide', list).slice(0, limit);
      if (items.length) track.replaceChildren(...items);
      syncWishlist(panel);
      initCarousels(panel);
    } catch { /* keep the server-rendered order */ }
  };
  const initTabs = (scope = document) => {
    const panels = $$('[data-tabpanel][data-sort-url]', scope).filter((p) => !p.hidden);
    if (!panels.length) return;
    if (!('IntersectionObserver' in window)) { panels.forEach(loadSorted); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { io.unobserve(en.target); loadSorted(en.target); } });
    }, { rootMargin: '600px' });
    panels.forEach((p) => io.observe(p));
  };
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tab]');
    if (!tab) return;
    const root = tab.closest('[data-tabs]');
    $$('[data-tab]', root).forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    $$('[data-tabpanel]', root).forEach((p) => {
      p.hidden = p.dataset.tabpanel !== tab.dataset.tab;
      if (!p.hidden) { loadSorted(p); initCarousels(p); }
    });
  });

  /* Countdown */
  const initCountdowns = (scope = document) => {
    $$('[data-countdown]', scope).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const end = new Date(el.dataset.countdown).getTime();
      if (Number.isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
        el.hidden = false;
        $('[data-d]', el).textContent = Math.floor(left / 864e5);
        $('[data-h]', el).textContent = pad(Math.floor((left % 864e5) / 36e5));
        $('[data-m]', el).textContent = pad(Math.floor((left % 36e5) / 6e4));
        $('[data-s]', el).textContent = pad(Math.floor((left % 6e4) / 1e3));
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  };

  /* Wishlist */
  const WISH_KEY = 'zz_wishlist';
  const getWish = () => store.get(WISH_KEY, []);
  function syncWishlist(scope = document) {
    const list = getWish();
    $$('[data-wishlist]', scope).forEach((b) => b.setAttribute('aria-pressed', list.includes(b.dataset.wishlist)));
    $$('[data-wishlist-count]').forEach((c) => { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.wishlist;
    const list = getWish();
    const has = list.includes(handle);
    const next = has ? list.filter((h) => h !== handle) : [handle, ...list].slice(0, 60);
    store.set(WISH_KEY, next);
    syncWishlist();
    toast(has ? T.strings.wishlistRemoved : T.strings.wishlistAdded);
    if (has) {
      const li = btn.closest('[data-wishlist-grid] > li');
      if (li) { li.remove(); renderWishlistEmpty(); }
    }
  });
  const cardFor = async (handle) => {
    const res = await fetch(`${T.routes.root.replace(/\/$/, '')}/products/${handle}?section_id=card-fragment`);
    if (!res.ok) return null;
    const card = $('.card', parse(await res.text()));
    if (!card) return null;
    const li = document.createElement('li');
    li.className = 'carousel__slide';
    li.append(card);
    return li;
  };
  const cardsFor = async (handles) => (await Promise.all(handles.map(cardFor))).filter(Boolean);
  const renderWishlistEmpty = () => {
    const grid = $('[data-wishlist-grid]');
    const empty = $('[data-wishlist-empty]');
    if (grid && empty) empty.hidden = grid.children.length > 0;
  };
  const initWishlistPage = async () => {
    const grid = $('[data-wishlist-grid]');
    if (!grid) return;
    grid.replaceChildren(...await cardsFor(getWish()));
    renderWishlistEmpty();
    syncWishlist(grid);
  };

  /* Recently viewed */
  const RECENT_KEY = 'zz_recent';
  const initRecent = async () => {
    const current = $('[data-product-root][data-product-handle]');
    const handle = current?.dataset.productHandle;
    const seen = store.get(RECENT_KEY, []);
    $$('[data-recently-viewed]').forEach(async (sec) => {
      const handles = seen.filter((h) => h !== handle).slice(0, Number(sec.dataset.limit) || 8);
      if (!handles.length) return;
      const cards = await cardsFor(handles);
      if (!cards.length) return;
      const track = $('[data-track]', sec);
      track.replaceChildren(...cards);
      sec.hidden = false;
      syncWishlist(sec);
      initCarousels(sec);
    });
    if (handle) store.set(RECENT_KEY, [handle, ...seen.filter((h) => h !== handle)].slice(0, 20));
  };

  /* Recommendations */
  const initRecommendations = () => {
    $$('[data-recommendations]').forEach(async (el) => {
      try {
        const res = await fetch(el.dataset.url);
        if (!res.ok) return;
        const fresh = $('[data-recommendations]', parse(await res.text()));
        if (fresh && fresh.children.length) {
          el.innerHTML = fresh.innerHTML;
          syncWishlist(el);
          initCarousels(el);
        }
      } catch { /* section stays empty */ }
    });
  };

  /* Sticky add to bag */
  const initSticky = () => {
    const bar = $('[data-sticky-atc]');
    const main = $('[data-main-buy]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => { bar.hidden = en.isIntersecting || en.boundingClientRect.top > 0; }).observe(main);
  };

  /* Filters */
  const facetsRoot = () => $('#FacetsRoot');
  const renderFacets = async (url, push = true) => {
    const root = facetsRoot();
    if (!root) return;
    root.classList.add('is-loading');
    const sep = url.includes('?') ? '&' : '?';
    try {
      const res = await fetch(`${url}${sep}section_id=${root.dataset.sectionId}`);
      const doc = parse(await res.text());
      const fresh = $('#FacetsRoot', doc);
      if (!fresh) throw new Error();
      const wasOpen = $('[data-facets-panel]', root)?.classList.contains('is-open');
      const closed = $$('.facet', root).map((d) => !d.open);
      root.replaceWith(fresh);
      if (wasOpen) $('[data-facets-panel]', fresh)?.classList.add('is-open');
      $$('.facet', fresh).forEach((d, i) => { if (closed[i]) d.open = false; });
      if (push) history.pushState({ facets: true }, '', url);
      syncWishlist(fresh);
      applyView();
      initInfinite();
    } catch { window.location.href = url; }
  };
  const applyFacets = () => {
    const form = $('[data-facets-form]');
    if (!form) return;
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form).entries()) if (v !== '') params.append(k, v);
    const loc = new URLSearchParams(window.location.search);
    ['q', 'type', 'options[prefix]'].forEach((k) => { if (loc.get(k) && !params.get(k)) params.set(k, loc.get(k)); });
    renderFacets(`${window.location.pathname}?${params.toString()}`);
  };
  const debouncedFacets = debounce(applyFacets, 650);
  document.addEventListener('input', (e) => { if (e.target.matches('[data-facets-input][data-debounce]')) debouncedFacets(); });
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facet-link]');
    if (link) { e.preventDefault(); renderFacets(link.getAttribute('href')); return; }
    if (e.target.closest('[data-facets-open]')) $('[data-facets-panel]')?.classList.add('is-open');
    if (e.target.closest('[data-facets-close]')) $('[data-facets-panel]')?.classList.remove('is-open');
    const view = e.target.closest('[data-view]');
    if (view) { store.set('zz_view', view.dataset.view); applyView(); }
    const panel = $('[data-facets-panel].is-open');
    if (panel && !e.target.closest('[data-facets-panel],[data-facets-open]')) panel.classList.remove('is-open');
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $('[data-facets-panel].is-open')?.classList.remove('is-open'); });
  window.addEventListener('popstate', () => { if (facetsRoot()) renderFacets(window.location.href, false); });

  function applyView() {
    const view = store.get('zz_view', 'grid');
    const grid = $('[data-product-grid]');
    if (!grid) return;
    grid.classList.toggle('product-grid--list', view === 'list');
    $$('.card', grid).forEach((c) => c.classList.toggle('card--list', view === 'list'));
    $$('[data-view]').forEach((b) => b.classList.toggle('is-active', b.dataset.view === view));
  }

  /* Load more and infinite scroll */
  const loadMore = async (btn) => {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    const root = facetsRoot();
    const url = btn.dataset.loadMore;
    try {
      const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${root.dataset.sectionId}`);
      const doc = parse(await res.text());
      const grid = $('[data-product-grid]', root);
      $$('[data-product-grid] > li', doc).forEach((li) => grid.append(li));
      const next = $('[data-load-more]', doc);
      if (next) { btn.dataset.loadMore = next.dataset.loadMore; btn.classList.remove('is-loading'); }
      else btn.closest('.load-more').remove();
      syncWishlist(grid);
      applyView();
    } catch { window.location.href = url; }
  };
  document.addEventListener('click', (e) => {
    const more = e.target.closest('[data-load-more]');
    if (more) loadMore(more);
  });
  let infiniteObserver;
  function initInfinite() {
    infiniteObserver?.disconnect();
    const btn = $('[data-load-more][data-infinite]');
    if (!btn || !('IntersectionObserver' in window)) return;
    infiniteObserver = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) loadMore(en.target); });
    }, { rootMargin: '500px' });
    infiniteObserver.observe(btn);
  }

  /* Predictive search */
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const searchUrl = (q) => `${T.routes.root.replace(/\/$/, '')}/search?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last`;
  const SEARCH_KEY = 'zz_searches';
  const showIdle = (box) => {
    const recent = store.get(SEARCH_KEY, []);
    const trending = (T.trending || []).map((t) => t.trim()).filter(Boolean);
    const block = (title, list) => (list.length
      ? `<p class="predictive__heading">${escapeHtml(title)}</p><div class="predictive__chips">${list.map((t) => `<a class="chip" href="${searchUrl(t)}">${escapeHtml(t)}</a>`).join('')}</div>`
      : '');
    const html = block(T.strings.recent, recent) + block(T.strings.trending, trending);
    box.innerHTML = html;
    box.hidden = !html;
  };
  const initPredictive = () => {
    $$('[data-predictive-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      const input = $('[data-predictive-input]', form);
      const box = $('[data-predictive-results]', form);
      if (!input || !box) return;
      let ctrl;
      const run = debounce(async () => {
        const q = input.value.trim();
        if (!q) { showIdle(box); return; }
        if (!T.predictiveSearch) { box.hidden = true; return; }
        ctrl?.abort();
        ctrl = new AbortController();
        try {
          const params = new URLSearchParams({ q, section_id: 'predictive-search', 'resources[limit]': '6', 'resources[type]': 'product,collection,page,query', 'resources[options][fields]': 'title,product_type,variants.title,vendor,tag' });
          const res = await fetch(`${T.routes.suggest}?${params}`, { signal: ctrl.signal });
          if (!res.ok) { box.hidden = true; return; }
          const doc = parse(await res.text());
          const content = $('.shopify-section', doc) || doc.body;
          box.innerHTML = content.innerHTML;
          box.hidden = !box.innerHTML.trim();
        } catch (err) { if (err.name !== 'AbortError') box.hidden = true; }
      }, 220);
      input.addEventListener('input', run);
      input.addEventListener('focus', () => { if (!input.value.trim()) showIdle(box); else run(); });
      form.addEventListener('submit', () => {
        const q = input.value.trim();
        if (q) store.set(SEARCH_KEY, [q, ...store.get(SEARCH_KEY, []).filter((s) => s !== q)].slice(0, 5));
      });
      document.addEventListener('click', (e) => { if (!form.contains(e.target)) box.hidden = true; });
      form.addEventListener('keydown', (e) => { if (e.key === 'Escape') { box.hidden = true; input.blur(); } });
    });
  };

  /* Fragrance finder quiz */
  const initFinder = (scope = document) => {
    $$('[data-finder]', scope).forEach((f) => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const steps = $$('[data-finder-step]', f);
      const results = $('[data-finder-results]', f);
      const grid = $('[data-finder-grid]', f);
      const none = $('[data-finder-none]', f);
      let answers = [];
      let current = 0;
      const show = (i) => { current = i; steps.forEach((s, n) => { s.hidden = n !== i; }); results.hidden = true; };
      const matches = (p, term) => {
        const tags = (p.tags || []).map((t) => t.toLowerCase());
        if (tags.includes(term)) return true;
        const re = new RegExp(`\\b${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
        return re.test(`${p.title} ${tags.join(' ')} ${p.body_html || ''}`);
      };
      const finish = async () => {
        steps.forEach((s) => { s.hidden = true; });
        results.hidden = false;
        grid.innerHTML = '';
        none.hidden = true;
        try {
          const res = await fetch(`${f.dataset.allUrl}/products.json?limit=250`);
          const { products } = await res.json();
          let max = Infinity; let min = 0;
          const terms = [];
          answers.forEach((a) => {
            const v = (a || '').trim().toLowerCase();
            if (!v) return;
            if (v.startsWith('max:')) max = Math.min(max, Number(v.slice(4)));
            else if (v.startsWith('min:')) min = Math.max(min, Number(v.slice(4)));
            else terms.push(v);
          });
          const priced = products.filter((p) => {
            const price = Number(p.variants?.[0]?.price || 0);
            return p.variants?.some((v) => v.available !== false) && price <= max && price >= min;
          });
          const pool = priced.length ? priced : products;
          const scored = pool
            .map((p) => ({ p, score: terms.filter((t) => matches(p, t)).length }))
            .sort((a, b) => b.score - a.score);
          const top = scored[0]?.score || 0;
          if (terms.length && top < terms.length) none.hidden = false;
          const picks = scored.slice(0, Number(f.dataset.count) || 6).map((s) => s.p.handle);
          grid.replaceChildren(...await cardsFor(picks));
          syncWishlist(grid);
        } catch { none.hidden = false; }
      };
      f.addEventListener('click', (e) => {
        const a = e.target.closest('[data-finder-answer]');
        if (a) {
          answers[current] = a.dataset.finderAnswer;
          if (current + 1 < steps.length) show(current + 1); else finish();
          return;
        }
        if (e.target.closest('[data-finder-back]')) { show(Math.max(0, current - 1)); return; }
        if (e.target.closest('[data-finder-restart]')) { answers = []; show(0); }
      });
    });
  };

  /* Newsletter popup */
  const initPopup = () => {
    const popup = $('[data-popup]');
    if (!popup || window.Shopify?.designMode) return;
    if ($('[data-popup-success]', popup)) { openDialog(popup); return; }
    const key = 'zz_popup';
    const days = Number(popup.dataset.days) || 14;
    const last = store.get(key, 0);
    if (last && Date.now() - last < days * 864e5) return;
    setTimeout(() => { if (!document.querySelector('dialog[open]')) { openDialog(popup); store.set(key, Date.now()); } }, (Number(popup.dataset.delay) || 10) * 1000);
  };

  /* Address forms */
  function syncProvinces(country) {
    const form = country.closest('form');
    const select = $('[data-province-select]', form);
    if (!select) return;
    const option = country.options[country.selectedIndex];
    const provinces = option ? JSON.parse(option.dataset.provinces || '[]') : [];
    select.replaceChildren(...provinces.map(([v, label]) => new Option(label, v, false, v === select.dataset.default)));
    select.closest('label').hidden = provinces.length === 0;
  }
  const initAddresses = () => {
    $$('[data-country-select]').forEach((c) => {
      if (c.dataset.default) c.value = c.dataset.default;
      syncProvinces(c);
    });
  };

  /* Back to top */
  const initBackToTop = () => {
    const btn = $('[data-back-to-top]');
    if (!btn) return;
    const onScroll = () => { btn.hidden = window.scrollY < 700; };
    window.addEventListener('scroll', debounce(onScroll, 80), { passive: true });
    onScroll();
  };

  const initAll = (scope = document) => {
    initCarousels(scope);
    initSliders(scope);
    initTabs(scope);
    initCountdowns(scope);
    initGallery(scope);
    initFinder(scope);
    syncWishlist(scope);
    initPredictive();
  };

  /* Theme editor support */
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const b = e.target;
    const mega = b.closest('.mega') || (b.classList.contains('mega') ? b : null);
    if (mega) mega.classList.add('is-editor-open');
    if (b.matches('[data-slide]')) b.parentElement.scrollTo({ left: b.offsetLeft - b.parentElement.offsetLeft });
    if (b.matches('[data-tab]')) b.click();
    if (b.matches('[data-rotator-item]')) { $$('[data-rotator-item]', b.parentElement).forEach((i) => i.classList.toggle('is-active', i === b)); }
    if (b.matches('[data-finder-step]')) { const d = b.closest('dialog'); if (d) openDialog(d); $$('[data-finder-step]', d).forEach((s) => { s.hidden = s !== b; }); }
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    e.target.closest('.mega')?.classList.remove('is-editor-open');
    e.target.classList?.remove('is-editor-open');
    const d = e.target.closest?.('dialog');
    if (d) closeDialog(d);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('[data-popup]')) openDialog($('[data-popup]', e.target));
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const p = e.target.querySelector('[data-popup]');
    if (p) closeDialog(p);
  });

  initAll();
  initWishlistPage();
  initRecent();
  initRecommendations();
  initSticky();
  applyView();
  initInfinite();
  initPopup();
  initAddresses();
  initBackToTop();
})();
